<template>
 <div class="faceee-container">
    <div id="login-div"></div>
    <div class="change-word">
      <router-link to="/change-password">修改密码</router-link>
    </div>
    <div class="get-help">
      如忘记密码中遇到问题，可通过钉钉联系"<a href="dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=megvii999">IT支持</a>"寻求帮助。
    </div>
  </div>
</template>

<script>
import FaceEELogin from "@/assets/js/faceee-login.min";
import {getFaceSign,faceCallback} from "@/api";

export default {
  name:"faceee",
  data(){
    return {
      instance:null
    }
  },
  mounted() {
this.initFaceEE();
  },
  methods:{
    initFaceEE(){
      this.getfaceeeUrl().then((oauthURL)=>{
        this.instance = new FaceEELogin({
          containerID: 'login-div',
          oauth: oauthURL,
          onResult: this.onResult.bind(this),
          loginCallback: this.loginCallback.bind(this)
        })
      })
    },
    resetFaceEE(){
      this.instance.destory();
      this.initFaceEE();
    },

    async getfaceeeUrl(){
      const { statusCode, data } = await getFaceSign();
      if(statusCode == 200) {
        return data.url;
      }
      this.$message.error("获取二维码路径报错");
    },

    onResult(isSuccess, status, msg){
      console.log("faceee初始化成功", isSuccess, status, msg)
    },

    loginCallback(code, state){
      console.log('loginCallback', code, state);
      this.faceeeCallback(code);
    },
    async faceeeCallback(code){
      const {statusCode,msg} = await faceCallback(code);
      if(statusCode == 200){
        if(msg == 'success'){
          this.$emit('changeStep', 2)
        }else if(msg=='failed'){
          // 重新初始化二维码
          this.$message.error("认证失败，请重试");
          this.resetFaceEE();
        }else if(msg=='cancelled'){
          // 重新初始化二维码
          this.$message.warning("用户取消认证");
          this.resetFaceEE();
        }else if(msg=='timeout'){
          // 重新初始化二维码
          this.$message.error("认证超时，请重试。");
          this.resetFaceEE();
        }
        console.log("身份信息验证成功");
      }
    }
  }
}
</script>

<style lang="less">
.faceee-login-container{
  height: 280px !important;
  overflow: hidden !important;
  scrollbar-width: none !important; /* firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
  overflow-x: hidden !important;
  overflow-y: auto !important;

  .findex_login-cancel{
    display: none !important;
  }
}

</style>

<style lang="less" scoped>
  .change-word {
    margin-top: 8px;
    text-align: right;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1067D1;
    line-height: 17px;
  }

  .get-help {
    margin-top: 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8E8E8E;
    line-height: 17px;
  }
</style>


